export enum McfaClaimStatus {
    New = "New",
    Pending = "Pending",
    Closed = "Closed",
}
